import { Component, inject } from '@angular/core';

import { PartnerService } from '../services/partner.service';

@Component({
  selector: 'app-marketing',
  standalone: true,
  imports: [],
  templateUrl: './marketing.component.html',
  styleUrl: './marketing.component.scss'
})
export class MarketingComponent {
  private partnerService = inject(PartnerService);
  readonly partner = this.partnerService.state.asReadonly();
}
